import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import styled, { withTheme } from 'styled-components';

import Link from '@ui/Link.tsx';
import Logo from '@ui/logo/Logo.tsx';

import SearchNav from './SearchNav.tsx';
import SearchNavMobile from './SearchNavMobile.tsx';
import { StyledHeader } from './StyledHeader.ts';
import { Title } from './styles.ts';

const LogoWrapper = styled.span`
  padding: 0 0 ${prop => (prop.$isDesktop ? '20px' : '0')} 0;
  display: block;
`;

export const Header = withTheme(
  ({
    theme,
    clientName,
    logoLinkUrl,
    searchPlaceholder,
    isDesktop,
    title,
    onSearchTermChange,
    onFocus,
    widgetState,
    handleToggleSearchButtonClick,
    handleOpenDirectionsSearchButtonClick,
    handleKeyPress,
    T,
    onUserMenuButtonClick,
    onBackButtonClicked,
    menuOptions,
  }) => {
    const [state, setWidgetState] = useState(widgetState.getState());

    useEffect(() => widgetState.addCallback(setWidgetState), [widgetState]);

    const renderSearchNav = () => {
      if (isDesktop) {
        return (
          <SearchNav
            searchPlaceholder={searchPlaceholder}
            onOpenDirectionsSearchButtonClick={handleOpenDirectionsSearchButtonClick}
            widgetState={widgetState}
            onSearchTermChange={onSearchTermChange}
            onFocus={onFocus}
            handleKeyPress={handleKeyPress}
            onBackButtonClicked={onBackButtonClicked}
            T={T}
          />
        );
      } else {
        return (
          <SearchNavMobile
            searchPlaceholder={searchPlaceholder}
            logoUrl={state.logoUrl}
            onOpenDirectionsSearchButtonClick={handleOpenDirectionsSearchButtonClick}
            onToggleSearchButtonClick={handleToggleSearchButtonClick}
            handleKeyPress={handleKeyPress}
            onUserMenuButtonClick={onUserMenuButtonClick}
            T={T}
            widgetState={widgetState}
            menuOptions={menuOptions}
          />
        );
      }
    };

    const getLogo = () =>
      state.logoUrl ? (
        // ? <StyledLogo linkUrl={logoLinkUrl} url={state.logoUrl} name={clientName} />
        <LogoWrapper $isDesktop={isDesktop}>
          {' '}
          <Link data-testid="logoLink" href={logoLinkUrl}>
            {' '}
            <Logo
              logoHeight={theme.logo.height}
              alt={clientName}
              url={state.logoUrl}
              width="auto"
              position={theme.logo.centered ? 'center' : 'left'}
              padding={theme.logo.padding}
            />{' '}
          </Link>
        </LogoWrapper>
      ) : (
        <Title>{title}</Title>
      );

    return (
      <StyledHeader
        className={!isDesktop ? '-mobile' : '-desktop'}
        $hasLogoUrl={!!state.logoUrl}
        data-testid="homeViewHeader"
      >
        {theme.header?.hasLogo || !isDesktop ? getLogo() : null}
        {renderSearchNav()}
      </StyledHeader>
    );
  },
);

Header.propTypes = {
  clientName: PropTypes.string.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  onSearchTermChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  handleToggleSearchButtonClick: PropTypes.func.isRequired,
  onUserMenuButtonClick: PropTypes.func.isRequired,
  handleOpenDirectionsSearchButtonClick: PropTypes.func.isRequired,
};
